import { useState, useEffect } from "react"
import { projectAuth, projectStorage, projectFirestore } from "../Firebase/Config"
import { useAuthContext } from "./useAuthContext"

export const useSignUp = () => {
    const [isCancelled, setIsCancelled] = useState(false);
    const [error, setError] = useState(null)
    const [isPending, setIsPending] = useState(null);

    const { dispatch } = useAuthContext()

    const signup = async (displayName, email, password, thumbnail) => {
        setError(null);
        setIsPending(true);
        try{
            // sign user to firebase
            const response = await projectAuth.createUserWithEmailAndPassword(email, password)
            if(!response){
                throw new Error('Could not complete signup')
            }

            // upload user thumbnail
            const uploadPath = `thumbnails/${response.user.uid}/${thumbnail.name}`;
            const image = await projectStorage.ref(uploadPath).put(thumbnail)
            const imageURL = await image.ref.getDownloadURL()

            // add display name to user profile
            await response.user.updateProfile({ displayName, photoURL: imageURL })

            // create a user documents
            await projectFirestore.collection('users').doc(response.user.uid).set({
                online: true, 
                displayName, 
                photoURL: imageURL
            })

            // dispatch login action
            dispatch({ type: 'LOGIN', payload: response.user })


            if(!isCancelled){
                setIsPending(false)
                setError(null)
            }
        }catch(err){
            console.log(err)
            if(!isCancelled){
                setError('Signup failed')
                setIsPending(false)
            }
        }
    }

    useEffect(() => {
        return () => setIsCancelled(true);
    },[])

    return { error, isPending, signup }
}